<div class="content">
  <div class="basic">
    <form [formGroup]="loginForm">
      <mat-form-field appearance="outline">
        <mat-label>Enter User Name</mat-label>
        <input matInput formControlName="userId" />
        <mat-error *ngIf="loginFormControls.userId.errors?.required">This field is required</mat-error>
      </mat-form-field>
      <div class="button-group">
        <button
          mat-button
          class="primary-button"
          [disabled]="loginForm.invalid"
          value="SUBMIT"
          data-type="submit"
          (click)="signIn()">
          Submit
        </button>
        <button mat-button style="margin-left: 5px" class="secondary-button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>
